

















import { computed, defineComponent, PropType } from '@vue/composition-api';
import { MenuConfigItem } from '../type';
import { fnIsRouteMatch } from '../util';
export default defineComponent({
  name: 'MenuItem',
  props: {
    menu: {
      type: Object as PropType<MenuConfigItem>,
      required: true,
    },
  },
  setup(props, { root, emit }) {
    const isActive = computed(() => fnIsRouteMatch(props.menu, root.$route));
    const fnClick = () => {
      if (isActive.value) return;
      emit('click');
    };
    return {
      isActive,
      fnClick,
    };
  },
});
